module.exports = __webpack_public_path__ + "img/resume-builder.ff673888.svg";